import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from '../views/MainLayout';
import Dashboard from '../views/MainLayout/components/Dashboard';
import Ajustes from '../views/MainLayout/components/Ajustes';
import Clientes from '../views/MainLayout/components/Clientes';
import ClienteSheet from '../views/MainLayout/components/Clientes/components/ClienteSheet';
import Comerciales from '../views/MainLayout/components/Comerciales';
import Devoluciones from '../views/MainLayout/components/Devoluciones';
import DevolucionContainer from '../views/MainLayout/components/Devoluciones/components/DevolucionContainer';
import Envios from '../views/MainLayout/components/Envios';
import Facturas from '../views/MainLayout/components/Facturas';
import Finanzas from '../views/MainLayout/components/Finanzas';
import Incidencias from '../views/MainLayout/components/Incidencias';
import FichaIncidencia from '../views/MainLayout/components/Incidencias/components/FichaIncidencia';
import Bastidores from '../views/MainLayout/components/Bastidores';
import Account from '../views/MainLayout/components/Account';
import Presupuestos from '../views/MainLayout/components/Presupuestos';
import FichaPresupuesto from '../views/MainLayout/components/Presupuestos/components/FichaPresupuesto';
import Proveedores from '../views/MainLayout/components/Proveedores';
import ProveedorSheet from '../views/MainLayout/components/Proveedores/components/ProveedorSheet';
import RecordatoriosClientes from '../views/MainLayout/components/RecordatoriosClientes';
import TecDoc from '../views/MainLayout/components/TecDoc';
import Users from '../views/MainLayout/components/Users';
import UserDetail from '../views/MainLayout/components/Users/components/UserDetail';
import Ventas from '../views/MainLayout/components/Ventas';
import Albaranes from '../views/MainLayout/components/Albaranes';
import AutorizacionesCredito from '../views/MainLayout/components/AutorizacionesCredito';
import DashboardPantalla from '../views/MainLayout/components/DashboardPantalla';
import DesguacesOffline from '../views/MainLayout/components/DesguacesOffline';
import NotasCargo from '../views/MainLayout/components/NotasCargo';
import Stock from '../views/MainLayout/components/Stock';
import Solicitudes from '../views/MainLayout/components/Solicitudes';
import Reconstruidos from '../views/MainLayout/components/Reconstruidos';
import Integraciones from '../views/MainLayout/components/Integraciones';
import Closer from '../views/MainLayout/components/Closer';
import SolicitudAlternativas from '../views/MainLayout/components/SolicitudAlternativas';
import Reparto from '../views/MainLayout/components/Reparto';

export const router = createBrowserRouter([
  {
    path: '/',
    element:
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '*', element: <Dashboard /> },
      { path: 'albaranes/:page', element: <Albaranes /> },
      { path: 'ajustes', element: <Ajustes /> },
      { path: 'autorizaciones-credito/:page', element: <AutorizacionesCredito /> },
      { path: 'avisos-stock/:page', element: <Stock /> },
      { path: 'clientes/:page', element: <Clientes /> },
      { path: 'cliente/:clienteId', element: <ClienteSheet /> },
      { path: 'comerciales/:page', element: <Comerciales pais={null} /> },
      { path: 'dashboard-pantalla/:page', element: <DashboardPantalla /> },
      { path: 'desguaces-offline/:page', element: <DesguacesOffline /> },
      { path: 'devoluciones/:page', element: <Devoluciones /> },
      { path: 'devolucion/:devolucionId', element: <DevolucionContainer /> },
      { path: 'ecommerce/:page', element: <Presupuestos ecommerce={true} soporte={false} /> },
      { path: 'envios/:page', element: <Envios /> },
      { path: 'facturas/:page', element: <Facturas /> },
      { path: 'finanzas', element: <Finanzas /> },
      { path: 'reparto', element: <Reparto /> },
      { path: 'incidencias/:page', element: <Incidencias /> },
      { path: 'incidencia/:incidenciaId', element: <FichaIncidencia /> },
      { path: 'matriculas/:page', element: <Bastidores /> },
      { path: 'mi-cuenta', element: <Account /> },
      { path: 'notas-cargo/:page', element: <NotasCargo /> },
      { path: 'portugal/:page', element: <Comerciales pais={'portugal'} /> },
      { path: 'presupuestos/:page', element: <Presupuestos ecommerce={false} soporte={false} /> },
      { path: 'presupuesto/:presupuestoId', element: <FichaPresupuesto /> },
      { path: 'proveedores/:page', element: <Proveedores /> },
      { path: 'proveedor/:proveedorId', element: <ProveedorSheet /> },
      { path: 'reconstruidos/:page', element: <Reconstruidos /> },
      { path: 'recordatorios', element: <RecordatoriosClientes /> },
      { path: 'solicitudes/:page', element: <Solicitudes /> },
      { path: 'tecdoc/:page', element: <TecDoc /> },
      { path: 'users/:page', element: <Users /> },
      { path: 'user/:userId', element: <UserDetail /> },
      { path: 'ventas/:page', element: <Ventas /> },
      { path: 'integraciones', element: <Integraciones /> },
      { path: 'closer/:page', element: <Closer /> },
      { path: 'solicitud-alternativas/:page', element: <SolicitudAlternativas /> },
    ]
  }
]);
